<!--
 * @Author: your name
 * @Date: 2021-06-29 17:19:20
 * @LastEditTime: 2022-01-06 11:46:51
 * @LastEditors: your name
 * @Description: yang
 * @FilePath: \web_bank\src\views\set.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div class="set">
    <div style="margin:auto;padding:0.973rem; 0.973rem;display:flex;align-items:center;">
      <van-image
        round
        width="4rem"
        height="4rem"
        :src="userInfo.avatar" rel="external nofollow" 
        v-if=" userInfo.avatar != null"
      />
      <van-image
        round
        width="4rem"
        height="4rem"
        :src="require('./img/avatar.png')" rel="external nofollow" 
        v-else
      />
      <div style="margin-left:0.9743rem;">
        {{userInfo.name}}
      </div>
    </div>
    <van-cell-group>
      <van-field left-icon="wap-home-o" label="所属学校" :value="userInfo.schoolName" readonly />
      <van-field left-icon="friends-o" label="性别" :value="sex" readonly />
      <van-field left-icon="phone-o" label="联系电话" :value="userInfo.telephone" readonly />
      <van-field left-icon="orders-o" label="卡号" :value="userInfo.schoolCardNum" readonly />
    </van-cell-group>
    <div style="width:95%;margin:auto;">
      <van-button  ref="btn" class="btn" type="primary" size="large"  @click="jieBang" style="margin-top:5rem;background:#F5AD3F;border:0px;border-radius:8px">解除绑定</van-button>
    </div>
  </div>
</template>

<script>
import {jieChu} from '@/api/http'
import { Toast } from 'vant';
export default {
  name: 'set',
  components: {
   
  },
  data(){
    return{
     userInfo:null
    }
  },
  methods:{
    //解除绑定
   jieBang(){
        sessionStorage.removeItem("token")
        //  sessionStorage.removeItem("openId")
        let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        jieChu(userInfo.id).then(res=>{
            console.log(res)
            if(res.data.code == 200){
                Toast.success('解绑成功');
                this.$router.replace('/manualBind');
            }
        })
        
   }
  },
  mounted(){
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    console.log(this.userInfo)
    if(this.userInfo.gender == 0){
      this.sex = "未知"
    }else if(this.userInfo.gender == 1){
      this.sex = "男"
    }else{
      this.sex = "女"
    }
  }
}
</script>
<style scoped>
    .set{
        width: 100%;
        height: 100%; 
    }
    
</style>